import axiosInstance from '../services/AxiosInstance';

export function getPurchasePlans(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`purchase-plan?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}&${filterQuery}`);
}

export function deletePurchasePlan(id) {
    return axiosInstance.delete(`purchase-plan/${id}`);
}

export function createPurchasePlan(data) {
    return axiosInstance.post(`purchase-plan`,data);
}

export function updatePurchasePlan(id, data) {
    return axiosInstance.put(`purchase-plan/${id}`,data);
}
